"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var browser_or_node_1 = require("browser-or-node");

var Storage =
/** @class */
function () {
  function Storage(name) {
    this.prefix = "legalizeSDK";
    this.name = "";
    this.name = name;
  }

  Storage.prototype.put = function (key, value) {
    if (browser_or_node_1.isBrowser) {
      localStorage.setItem(this.makeKey(key), JSON.stringify(value));
    }
  };

  Storage.prototype.get = function (key) {
    if (browser_or_node_1.isBrowser) {
      var data = localStorage.getItem(this.makeKey(key));

      try {
        return JSON.parse(data);
      } catch (error) {
        return undefined;
      }
    }

    return undefined;
  };

  Storage.prototype.remove = function (key) {
    if (browser_or_node_1.isBrowser) {
      localStorage.removeItem(this.makeKey(key));
    }
  };

  Storage.prototype.makeKey = function (key) {
    return this.prefix + "/" + this.name + "/" + key;
  };

  return Storage;
}();

exports.default = Storage;